module.exports = __webpack_public_path__ + "img/train-7.ff66c16d.jpg";